import React from 'react'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, View } from 'react-native'
import { Text } from 'react-native-paper'
import { InvoiceIcon } from '../../../../../../assets/icons'
import SModal from '../../../../../../ui/molecules/SModal'
import Loading from '../../../../../Loading'
import { styles } from '../styles'

type DeleteModalPropType = {
  visible: boolean
  deleteNote: () => void
  closeModal: () => void
  loading: boolean
}

export const DeleteConfirmModal = (props: DeleteModalPropType) => {
  const { visible, deleteNote, closeModal, loading } = props
  const { t } = useTranslation('global')
  return (
    <SModal
      visible={visible}
      onClose={deleteNote}
      containerStyle={{ width: 450 }}
    >
      <View style={styles.contentModalWrapper}>
        <InvoiceIcon />
        <Text
          style={[styles.modalTitle, { marginTop: 20 }]}
          testID="are_you_sure_label"
        >
          {t('InvoiceNotes.are_u_sure')}
        </Text>
        <Text style={styles.modalTitle} testID="delete_note_label">
          {t('InvoiceNotes.delete_note')}
        </Text>
        <View style={styles.buttonsContainer}>
          <TouchableOpacity
            testID={`projects-detail-view-sidebar-delete-go-back`}
            style={[styles.modalButton, { backgroundColor: '#E6F2FA' }]}
            onPress={closeModal}
          >
            <Text style={styles.cancelText} testID="go_back_label">
              {t('InvoiceNotes.no_go_back')}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            testID={`projects-detail-view-sidebar-delete-yes`}
            style={[styles.modalButton, { backgroundColor: '#007FCF' }]}
            onPress={deleteNote}
          >
            {loading ? (
              <Loading />
            ) : (
              <Text style={styles.confirmText}>
                {t('InvoiceNotes.yes_delete')}
              </Text>
            )}
          </TouchableOpacity>
        </View>
      </View>
    </SModal>
  )
}
